import { ListItem, ListItemButton, ListItemText } from '@mui/material'
import React from 'react'
import { Link } from 'react-router-dom'

import { NOTIFICATION_LEFT_PADDING } from 'components/navigation/Notifications/utils'
import { NotificationDetail } from 'types/api/reliability-tests/notifications'

export type NotificationItem = NotificationDetail | Record<string, any>

const ListItemContent: React.FC<{ item: NotificationItem }> = ({
  item,
  ...rest
}) => {
  return (
    <ListItemText
      secondary={item.text}
      sx={{ pl: NOTIFICATION_LEFT_PADDING }}
      {...rest}
    />
  )
}

export const NotificationsListItem: React.FC<{
  notification: NotificationItem
}> = ({ notification }) => {
  return notification.path ? (
    <ListItem component="div">
      <ListItemButton
        data-test-notification-item
        component={Link}
        to={notification.path}
      >
        <ListItemContent data-test-notification-text item={notification} />
      </ListItemButton>
    </ListItem>
  ) : (
    <ListItem component="div">
      <ListItemContent data-test-notification-item item={notification} />
    </ListItem>
  )
}
